module.exports = __webpack_public_path__ + "img/user9.b0f3de7a.png";